<template>
  <div class="serviceinfo" v-if="form && form.name">
    <div style="width:60%;float:left">
      <div class="serviceinfo-top">
        <div class="desc">
          <cardItem class="desc-item" :item="form" type="info" />
        </div>
      </div>
      <div class="serviceinfo-btm mt-16 mb-24">
        <div class="left carddom">
          <Tabs v-model="activeTab" class="fontcursor">
            <TabPane label="服务介绍" name="introduce"></TabPane>
            <TabPane label="版本说明" name="version"></TabPane>
            <TabPane label="技术规格" name="skill"></TabPane>
            <TabPane :label="`服务评价(${evaluationCount})`" name="evaluate"></TabPane>
          </Tabs>
          <div class="introduce mt-8" id="introduceanchor" v-show="activeTab == 'introduce'">
            <p class="mb-24 font16 fontbig">
              <a name="introduce" class="fonttwodark">服务介绍</a>
            </p>
            <p class="mt-24 serviceIntroduce lineBreak" v-html="form.serviceIntroduce"></p>
          </div>
          <div id="versionanchor" v-show="activeTab == 'version'">
            <div v-if="versionList.length == 0">暂无数据</div>
            <div v-else class="version-wrapper">
              <div class="line"></div>
              <div class="container">
                <div
                  class="item"
                  :class="{'mb-24': index != versionList.length - 1}"
                  v-for="(item, index) in versionList"
                  :key="index"
                >
                  <div class="circle"></div>
                  <div class="content">
                    <div class="version mb-12">
                      <label class="label6">版本号：</label>
                      <div>{{ item.version }}</div>
                    </div>
                    <div class="describe mb-12">
                      <label class="label6">版本说明：</label>
                      <div class="lineBreak">{{ item.versionDesc }}</div>
                    </div>
                    <div class="update-time">
                      <label class="label6">更新时间：</label>
                      <div class="lineBreak">{{ item.createTime }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="skillanchor"  v-if="activeTab == 'skill'">
            <!-- <p class="mb-24 mt-32 fontbig font16">
            <a name="doc" class="fonttwodark">技术规格</a>
          </p>
          <div class="infokv">
            <label class="label6">分析源类型：</label>
            <div>
              <span v-if="!form.sourceType">暂无数据</span>
              <img
                class="w64px mr-12"
                src="@/assets/img/service/imgInfoActive.png"
                v-if="form.sourceType == 0 || form.sourceType == '0,1'"
              />
              <img
                class="w64px"
                src="@/assets/img/service/videoInfoActive.png"
                v-if="form.sourceType == 1 || form.sourceType == '0,1'"
              />
            </div>
            </div>-->
            <div>
              <Table :columns="imgCol" :data="imgTable"></Table>
              <Table :columns="cpuCol" class="mt-24" :data="cpuTable"></Table>
              <Table :columns="threeCol" :data="threeTable" class="mt-24"></Table>
            </div>
          </div>
          <div
            v-show="activeTab == 'evaluate' && !evaluationCount"
            class="none-evaluate flexcolcenter"
          >
            <img class="mt-10 mb-10" src="@/assets/img/msg/msg_null.png" alt />
            <span>暂无评价</span>
          </div>
          <div
            v-show="activeTab == 'evaluate' && evaluationCount"
            class="evaluate"
            id="evaluateanchor"
          >
            <div class="summary">
              <div class="score">
                <div class="title">服务评分</div>
                <div class="rate">{{form.score.toFixed(1)}}</div>
                <Rate allow-half :value="form.score" disabled />
              </div>
              <div class="line"></div>
              <div class="list">
                <div
                  class="item"
                  :class="{ 'active': selectTag.indexOf(item.tag) != -1 }"
                  v-for="item in commentLabel"
                  :key="item.tag"
                  @click="changeTag(item.tag)"
                >{{`${item.title}(${item.num})`}}</div>
              </div>
            </div>
            <div class="evaluation-type">
              <div
                class="evaluation-item"
                :class="{'active': evaluationActive == item.active}"
                v-for="item in evaluationType"
                :key="item.key"
                @click="changeEvaluationType(item)"
              >{{item.title}}({{item.num}})</div>
            </div>
            <div v-show="evaluateList.length > 0">
              <evaluateItem v-for="(item, index) in evaluateList" :item="item" :key="index" />
            </div>
          </div>
          <div
            v-show="activeTab == 'evaluate' && evaluationCount && !search.pageTotal"
            class="mt-20 none-evaluate flexcolcenter"
          >
            <img class="mt-10 mb-10" src="@/assets/img/msg/msg_null.png" alt />
            <span>暂无该类型评价</span>
          </div>
          <Row
            v-show="activeTab == 'evaluate' && evaluationCount && search.pageTotal"
            class="mt-16 mr-32"
            type="flex"
            justify="center"
          >
            <Page
              :total="search.pageTotal"
              :page-size="search.pageSize"
              :page-size-opts="psize"
              :current="search.pageIndex"
              @on-change="handlePage"
              @on-page-size-change="sizeChange"
              show-sizer
              show-total
              show-elevator
              placement="top"
              class-name="page"
            />
          </Row>
          <!-- <Button shape="circle" class="w104px mt-16" @click="link('/serve/servelist')">返回</Button> -->
        </div>
        <!-- <div class="right carddom">
        <p class="font16 fontbig fontdark mb-24">服务商简介</p>
        <div class="flexfs companyname">
          <img v-if="form.logo" class="mr-16 oLogo" :src="form.logo" alt />
          <img v-else src="@/assets/img/user/company_default_logo.png" class="mr-16 oLogo" />
          <div class>
            <p class="font14 fontdark fontbig mb-4">{{ form.oName }}</p>
            <p class="font12">服务提供商</p>
          </div>
        </div>
        <p class="mt-50">{{ form.oIntroduce }}</p>
        </div>-->
      </div>
    </div>
    <serviceBrief :form="form" style="float:left" />
  </div>
</template>

<script>
import cardItem from "@/components/card/card-item.vue";
import evaluateItem from "@/components/card/evaluate-item.vue"; //评价组件
import {
  serviceDetail,
  serviceComment,
  getVersion,
  serviceCommentNew,
  getEachNum
} from "@/api/service"; //详情，评论接口
import { getDict } from "@/api/dict";
import serviceBrief from "../components/serviceBrief.vue";
const imgCol = [
  {
    title: "图片规格",
    key: "imageFormat",
    // width: 110
  },
  {
    title: "单路每秒处理图片占用芯片百分比",
    // width: 300,
    key: "chipRatio"
  },
  {
    title: "单路每秒处理图片数量",
    key: "images"
  },
  {
    title: "单路芯片每秒最大处理数",
    key: "qps"
  }
];
const cpuCol = [
  {
    title: "硬盘占用(M)",
    key: "disk"
  },
  {
    title: "内存占用(M)",
    key: "ram"
  },
  {
    title: "显存占用(M)",
    key: "vom"
  },
  {
    title: "支持最大路数",
    key: "maxRoad"
  }
];
const threeCol = [
  { title: "检测目标最小像素值", key: "aimMinPixel" },
  { title: "算法使用方式", key: "serviceUseWay" },
  { title: "视频帧率", key: "videoFramerate" },
  { title: "结果展示方式", key: "resultShowWay" }
];
export default {
  name: "",
  components: {
    cardItem,
    evaluateItem,
    serviceBrief
  },
  data() {
    return {
      evaluationActive: "all",
      commentLabel: [],
      selectTag: [],
      evaluationCount: 0, // 评论的总数量
      imgCol: imgCol,
      cpuCol: cpuCol,
      imgTable: [],
      cpuTable: [],
      versionList: [],
      psize: [1, 2, 3, 4],
      search: {
        pageTotal: 0,
        pageIndex: 1,
        pageSize: 4
      },
      activeTab: "introduce",
      serveDetailId: null,
      tagList: [],
      form: {},
      evaluateList: [],
      companyinfo: {},
      threeCol: threeCol,
      threeTable: [],
      evaluationType: [
        { title: "全部评价", num: 0, active: "all", value: "" },
        { title: "好评", num: 0, active: "good", value: 1 },
        { title: "中评", num: 0, active: "medium", value: 2 },
        { title: "差评", num: 0, active: "bad", value: 3 }
      ]
    };
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题
    "search.pageTotal"() {
      const cPage = this.search.pageTotal / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.serviceComment(); //获取列表数据
      }
    }
  },
  created() {
    this.serveDetailId = this.$route.query.id; //获取列表页传递的服务id
    this.getTag();
    this.getVersionList();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); // 离开页面 关闭监听 不然会报错
  },
  methods: {
    changeEvaluationType(item) {
      this.search.pageSize = 4;
      this.search.pageIndex = 1;
      this.evaluationActive = item.active;
      this.search.commentType = item.value;
      this.serviceComment();
    },
    changeTag(tag) {
      this.search.pageSize = 4;
      this.search.pageIndex = 1;
      let i = this.selectTag.indexOf(tag);
      if (i == -1) {
        this.selectTag.push(tag);
      } else {
        this.selectTag.splice(i, 1);
      }
      this.search.tagArray = this.selectTag;
      this.serviceComment();
      console.log(tag);
    },
    getEachNum() {
      getEachNum(this.serveDetailId).then(res => {
        let json = res.data.data;
        json.forEach(item => {
          let obj = {
            title: this.tagList.find(item2 => item2.v == item.tag).k,
            tag: item.tag,
            num: item.tagCount
          };
          this.commentLabel.push(obj);
        });
        console.log(this.commentLabel);
      });
    },
    getVersionList() {
      getVersion(this.serveDetailId).then(res => {
        console.log(res, "res--");
        this.versionList = res.data.data;
      });
    },
    //设置图片规格和cpu规格
    cpuAndImgRule() {
      let cpuObj = {
        disk: this.form.disk ? this.form.disk : "暂无数据",
        ram: this.form.ram ? this.form.ram : "暂无数据",
        vom: this.form.vom ? this.form.vom : "暂无数据",
        maxRoad: this.form.maxRoad ? this.form.maxRoad : "暂无数据"
      };
      this.cpuTable.push(cpuObj);
      let imgObj = {
        imageFormat: this.form.imageFormat
          ? this.form.imageFormat
          : "1920*1080",
        chipRatio: this.form.chipRatio ? this.form.chipRatio + "%" : "暂无数据",
        images: this.form.images ? this.form.images : "暂无数据",
        qps: this.form.qps ? this.form.qps : "暂无数据"
      };
      this.imgTable.push(imgObj);
      let obj = {
        aimMinPixel: this.form.aimMinPixel || "暂无数据",
        serviceUseWay: this.getServiceUseWay(this.form.serviceUseWay),
        videoFramerate: this.form.videoFramerate || "暂无数据",
        resultShowWay: this.getResultShowWay(this.form.resultShowWay)
      };
      this.threeTable.push(obj);
    },
    getServiceUseWay(value) {
      if (value == "0") return "全部";
      if (value == 1) return "视频流";
      if (value == 2) return "图片数据";
      return "暂无数据";
    },
    getResultShowWay(value) {
      if (value == "0") return "全部";
      if (value == 1) return "视频流";
      if (value == 2) return "图片展示";
      if (value == 3) return "推理结果";
      return "暂无数据";
    },
    // 获取服务详情数据
    getDetail() {
      serviceDetail(this.serveDetailId).then(res => {
        console.log("我的服务==服务详情", res);
        this.form = res.data.data;
        this.cpuAndImgRule();
      });
    },
    serviceComment() {
      serviceCommentNew(this.serveDetailId, this.search).then(res => {
        console.log("服务详情评价", res);
        this.evaluationCount = res.data.data.allTotalCount;
        let list = res.data.data.list;
        let json = res.data.data.commentType;
        console.log(list, "list---");
        //0不匿名 1匿名
        if (list && list.length) {
          list.forEach(item => {
            item.name = item.isHidden == "0" ? item.applicationName : "匿名";
            item.tags.forEach((x, index) => {
              let t = this.tagList.find(y => y.v == x);
              if (t) {
                item.tags[index] = t.k;
              }
            });
          });
        }
        this.evaluationType[0].num = json.commentCount;
        this.evaluationType[1].num = json.goodCommentCount;
        this.evaluationType[2].num = json.middleCommentCount;
        this.evaluationType[3].num = json.badCommentCount;
        this.search.pageTotal = res.data.page.totalCount; //评论数量
        this.evaluateList = list;
        console.log("this.evaluateList", this.evaluateList);
      });
    },
    getTag() {
      getDict("SERVICE_TAG").then(res => {
        this.tagList = res.data.data;
        this.getDetail(); //获取详情
        this.serviceComment(); //获取评论
        this.getEachNum();
        console.log(res, "评论列表");
      });
    },
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
    },
    tabClick(name) {
      document.getElementById(`${name}anchor`).scrollIntoView();
    },
    link(path, id, e) {
      if (e) e.stopPropagation();
      if (id) {
        this.$router.push({
          path: path,
          query: {
            companyId: this.form.companyId //当前无companyId(写死,测试)
          }
        });
      } else {
        this.$router.push({
          path: path
        });
      }
    },
    handlePage(value) {
      let self = this;
      self.search.pageIndex = value;
      self.serviceComment();
    },
    sizeChange(value) {
      let self = this;
      self.search.pageSize = value;
      self.$nextTick(() => {
        self.serviceComment();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.serviceinfo {
  width: 100%;
  &-top {
    width: 100%;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
    border-radius: 8px;
    .bread {
      border-bottom: 1px solid #f6f7f9;
      padding: 14px 32px;
      color: #919caf;
    }
    .desc {
      &-item {
        padding: 30px 32px;
      }
    }
  }
  &-btm {
    position: relative;
    display: flex;
    align-items: flex-start;
    .evaluation-type {
      display: flex;
      align-items: flex-end;
      margin-top: 24px;
      padding-bottom: 6px;
      border-bottom: 1px solid #dcdfe6;
      .evaluation-item {
        margin-right: 32px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #67799c;
        cursor: pointer;
      }
      .active {
        font-size: 16px;
        font-family: MicrosoftYaHeiSemibold;
        color: #67799c;
      }
    }
    .summary {
      margin-top: 20px;
      background: rgba(246, 246, 246, 0.6);
      border-radius: 8px;
      padding: 16px;
      display: flex;
      align-items: center;
      .score {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        .title {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #2f4061;
        }
        .rate {
          font-size: 24px;
          font-family: Altinn-DINExp-Bold, Altinn-DINExp;
          font-weight: bold;
          color: #ffaa00;
        }
      }
      .line {
        height: 100px;
        width: 1px;
        background-color: #dcdfe6;
        margin-right: 50px;
        flex-shrink: 0;
      }
      .list {
        margin-bottom: -10px;
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        .item {
          border-radius: 3px;
          border: 1px solid #dcdfe6;
          padding: 2px 30px;
          margin: 0 20px 10px 0;
          cursor: pointer;
          &.active {
            color: #3c8aff;
            background: rgba(60, 138, 255, 0.1);
          }
        }
      }
    }
    .version-wrapper {
      position: relative;
      margin-top: 45px;
      .line {
        position: absolute;
        left: 10px;
        width: 4px;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(60, 138, 255, 0.4) 0%,
          rgba(111, 190, 255, 0) 100%
        );
      }
      .container {
        .item {
          display: flex;
          align-items: center;
          .circle {
            flex-shrink: 0;
            width: 22px;
            height: 22px;
            background: #ffffff;
            border: 5px solid #3c8aff;
            border-radius: 50%;
            box-shadow: 0px 2px 16px 0px #3c8aff;
            z-index: 10;
          }
          .content {
            flex-grow: 1;
            margin-left: 26px;
            background: rgba(60, 138, 255, 0.08);
            position: relative;
            border-radius: 8px;
            padding: 16px 16px 20px;
            &::after {
              content: "";
              display: block;
              position: absolute;
              border: 10px solid rgba(60, 138, 255, 0.08);
              border-left-color: transparent;
              border-top-color: transparent;
              border-bottom-color: transparent;
              top: 50%;
              left: -20px;
              transform: translateY(-50%);
            }
            .version,
            .describe,
            .update-time {
              display: flex;
              label {
                flex-shrink: 0;
              }
            }
          }
        }
      }
    }
    .left {
      // width: 914px;
      width: 100%;
      color: #67799c;
      // margin-right: 20px;
      .video {
        border-radius: 8px;
      }
      .video:focus {
        outline: none;
      }
      .serviceIntroduce {
        text-align: justify;
        img {
          max-width: 100%;
        }
      }
    }
    .right {
      width: 27%;
      color: #919caf;
      .companyname {
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
